import { render } from "./Index_index_m.vue?vue&type=template&id=fc227e6a&scoped=true"
import script from "./Index_index_m.vue?vue&type=script&lang=js"
export * from "./Index_index_m.vue?vue&type=script&lang=js"

import "./Index_index_m.vue?vue&type=style&index=0&id=fc227e6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc227e6a"

export default script